import { createAction } from 'typesafe-actions';
import { SubscribeMessage } from './types';

export const INIT_CHAT_MESSAGES = 'chatMessages/INIT_CHAT_MESSAGES';

export const UPDATE_CHAT_MESSAGES = 'chatMessages/UPDATE_CHAT_MESSAGES';

export const READ_CHAT_MESSAGES = 'chatMessages/READ_CHAT_MESSAGES';

export const initChatMessages = createAction(INIT_CHAT_MESSAGES)();

export const readChatMessages = createAction(READ_CHAT_MESSAGES)();

export const updateChatMessages = createAction(UPDATE_CHAT_MESSAGES)<
  SubscribeMessage
>();
